export default __webpack_public_path__ + "static/media/case.27c700df.svg";